module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_modernmind-37c7ff004fc711746847dd68b43f8cb8.svg";